import Unit from '@/utils/unit/unit';

export const emptyUnit = new Unit('');
export const kiloWattUnit = new Unit('kW', new Map<number, string>([[1000, 'MW']]));
export const kiloWattHourUnit = new Unit('kWh', new Map<number, string>([[1000, 'MWh']]));
export const kilogramUnit = new Unit('kg', new Map<number, string>([[1000, 't']]));
export const celsiusUnit = new Unit('°C');
